import React from 'react';
import PropTypes from 'prop-types';
import css from './DismissButton.css';
import Icon from '../SF/MaterialIcon';

export default class DismissButton extends React.Component {

  render() {
    return (
        <div 
        	onClick={this.props.onClick} 
        	aria-label="Close navigation menu"
        	tabIndex="0" 
        	role="button">
          <Icon icon='close' className={css['button']} />
        </div>
    );
  }
}

DismissButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
